

























































































































































































































































































import Vue from 'vue';
import firebase from '../plugins/firebase';

const fb = firebase.database().ref('messages');
export default Vue.extend({
  name: 'home',

  data: () => ({
    snackbar: false,
    dialog: false,
    valid: true,
    name: '',
    nameRules: [
      (v: any) => !!v || 'Name is required',
      (v: any) =>
        (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    organisation: '',
    organisationRules: [
      (v: any) => !!v || 'Organisation is required',
      (v: any) =>
        (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    email: '',
    emailRules: [
      (v: any) => !!v || 'E-mail is required',
      (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    phone: '',
    phoneRules: [
      (v: any) => !!v || 'Phone is required',
      (v: any) =>
        /^\+?([0-9])\)?[-. ]?([0-9])[-. ]?([0-9])+/.test(v) ||
        'Phonel must be valid',
    ],
    services: null,
    servicesRules: [(v: any) => !!v || 'At least ONE service must be selected'],
    servicesList: [
      'Consulting',
      'Development',
      'Data Migration',
      'Systems Integration',
      'Training',
      'Support',
      'Other Services',
    ],
    message: '',
    messageRules: [
      (v: any) => !!v || 'Message is required',
      (v: any) =>
        (v && v.length <= 1000) || 'Name must be less than 1000 characters',
    ],
    checkbox: false,
    lazy: true,
  }),
  methods: {
    submit: function() {
      let data = {
        name: this.name,
        organisation: this.organisation,
        email: this.email,
        phone: this.phone,
        services: this.services,
        message: this.message,
      };
      if (this.$refs.form.validate()) {
        fb.push(data).then(() => {
          this.snackbar = true;
          this.dialog = !this.dialog;
        });
      }
      // console.log('valid :', this.$refs.form.validate());
      // console.log('event :', data);
    },
  },
});
